import React from 'react';
import DeviceStore from '../stores/device-store';
import UserStore from '../stores/user-store';
import Device from './device';
import Dispatcher from '../dispatcher';
import {VstLoader} from 'vstui';
import Utils from '../utils/utils';

export default class DevicesContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      devices: DeviceStore.getAll(),
      user: UserStore.get()
    };

    this._handleUserChange = this._handleUserChange.bind(this);
    this._handleDevicesChange = this._handleDevicesChange.bind(this);
  }

  componentDidMount() {
    Dispatcher.on(Dispatcher.USER_STORE_CHANGE, this._handleUserChange);
    Dispatcher.on(Dispatcher.DEVICE_STORE_CHANGE, this._handleDevicesChange);
  }

  componentWillUnmount() {
    Dispatcher.removeListener(Dispatcher.USER_STORE_CHANGE, this._handleUserChange);
    Dispatcher.removeListener(Dispatcher.DEVICE_STORE_CHANGE, this._handleDevicesChange);
  }

  _handleDevicesChange() {
    this.setState({devices: DeviceStore.getAll() });
  }

  _handleUserChange() {
    this.setState({user: UserStore.get() });
  }

  render() {
    let deviceList;
    if (this.state.devices){
      if (this.state.devices.length > 0){
        deviceList = (
          <div className="deck device-list">
            {this.state.devices.map( (device)=> {
              if (device.active){
                return <Device {...device} key={`device-${device.id}`} />;
              }
            })}
          </div>
        );
      } else {
        deviceList = <span>{i18n.t('devices.no-active')}</span>
      }
    } else {
      deviceList = (
        <div className="deck device-list">
          <VstLoader delay={500}>{i18n.t('devices.loading')}</VstLoader>
        </div>
      );
    }

    let desktopActivations = (this.state.user && this.state.user.maxDesktopActivations) || 0;
    let mobileActivations = (this.state.user && this.state.user.maxMobileActivations) || 0;
    return (
      <div className="page devices">
        <h1>{i18n.t('base.devices')}</h1>
        <p className="page-description">{Utils.toHTML(i18n.t('devices.description', {brand: Mulligan.Brand.brand, desktop: desktopActivations, mobile: mobileActivations}))}</p>
        {deviceList}
      </div>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/js/components/devices-container.jsx
 **/